import React from 'react';
import VaphToken from '../../organisms/settings/VaphToken';
import SettingsNavigation, { SettingsNavigationPage } from '../../organisms/settings/SettingsNavigation';

const VaphTokenPage: React.FC = () => {
  return (
    <SettingsNavigation selected={SettingsNavigationPage.VaphToken}>
      <VaphToken />
    </SettingsNavigation>
  );
};

export default VaphTokenPage;

